import * as Services from "../services/Services"
import * as Url from "../services/Url"


export const getAllEmployee = async() => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_EMPLOYEES, token)
  return res;
};

export const getAllEmployeebyContractor = async(tenant_id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_EMPLOYEES_BY_CONTRACTOR+tenant_id, token)
  return res;
};

export const getEmployeeDetails = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GET_EMPLOYEE_DETAILS}/${id}`, token)
  return res;
};

export const addEmployee = async(payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_EMPLOYEE, payload, token)
  return res;
};

export const updateEmployee = async(id, payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.PUT(`${Url.UPDATE_EMPLOYEE}/${id}`, payload, token)
  return res;
};

export const deleteEmployeeByID = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.DELETE(`${Url.DELETE_EMPLOYEE}/${id}`, {}, token)
  return res;
};

export const updateEmployeeProfile = async(id, payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.PUT(`${Url.UPDATE_EMPLOYEE_PROFILE}/${id}`, payload, token)
  return res;
};

export const uploadEmployeeImage = async(id, formData) => {
  let token = localStorage.getItem("token");
  let res = await Services.UPLOAD(`${Url.UPLOAD_EMPLOYEE_IMAGE}/${id}`, formData, token)
  return res;
};
